class chartWeight extends HTMLElement {
  constructor() {
    super();
    this.chartContext = this.querySelector("#weightChart");
    this.data = this.querySelector("#weight-data");
  }

  connectedCallback() {
    // Wait for next tick to ensure Chart.js is fully loaded
    setTimeout(() => {
      if (!window.Chart) {
        console.error("Chart.js not loaded");
        return;
      }
      this.renderChart();
    }, 0);
  }

  renderChart() {
    const Chart = window.Chart;
    if (!this.chartContext) {
      console.error("Weight chart canvas not found");
      return;
    }

    if (!this.data) {
      console.error("Weight data not found");
      return;
    }

    const measurements = JSON.parse(this.data.textContent);
    const generateDateLabels = measurements.map(({ measured_at }) =>
      new Date(measured_at).toLocaleDateString()
    );
    const generateValues = measurements.map(({ value }) => value);

    const ctx = this.chartContext.getContext("2d");
    new Chart(ctx, {
      type: "line",
      data: {
        labels: generateDateLabels,
        datasets: [
          {
            label: "Weight (g)",
            data: generateValues,
            borderColor: "rgb(75, 192, 192)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            tension: 0.1,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: false,
            title: {
              display: true,
              text: "Weight (g)",
            },
          },
          x: {
            title: {
              display: true,
              text: "Date",
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: "top",
          },
          title: {
            display: true,
            text: "Weight Tracking over time",
          },
        },
      },
    });
  }
}

customElements.define("chart-weight", chartWeight);
